module.exports = __webpack_public_path__ + "ab004e15dc8b745ad883396c49875cf6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/logo2.png
 ** module id = 210
 ** module chunks = 1
 **/